<div class="table-container">
  <table mat-table [dataSource]="kfConfigurations" matSort>

    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.year" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.year}} </td>
    </ng-container>

    <ng-container matColumnDef="level">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Level </th>
      <td mat-cell *matCellDef="let config"> {{config.schemaKind === 'COUNTRY_SCHEMA' ? 'Country' : 'WEEE-System'}} </td>
    </ng-container>

    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Entry </th>
      <td mat-cell *matCellDef="let config"> {{config.schemaKind === 'COUNTRY_SCHEMA' ? config.countryName : config.systemName}} </td>
    </ng-container>

    <ng-container matColumnDef="unuKeySetName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.UNU-key-set" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.unuKeySetName}} </td>
    </ng-container>

    <ng-container matColumnDef="kfCategorySetName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.key-figure-category-set" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.kfCategorySetName}} </td>
    </ng-container>

    <ng-container matColumnDef="collectionStreamName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.collection-stream-set" | translate }} </th>
      <td mat-cell *matCellDef="let config"> {{config.collectionStreamName}} </td>

    </ng-container>


    <ng-container matColumnDef="launched">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.launched" | translate }} </th>
      <td mat-cell *matCellDef="let config">
        {{config.launched ? config.launched : (config.lifeCycleStatus ? capitalize(config.lifeCycleStatus) : 'Not started')}}
      </td>
    </ng-container>

    <ng-container matColumnDef="open">
      <th mat-header-cell *matHeaderCellDef> Open </th>
      <td mat-cell *matCellDef="let config">
        {{config.isReopened ? 'Yes' : 'No'}}
      </td>
    </ng-container>


    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let config" [align]="'right'">
<!--        <mat-icon *ngIf="config.isReopened" (click)="reopen(config)">lock_open</mat-icon>-->
        <button *ngIf="!config.isReopened" mat-icon-button color="primary" matTooltip="Reopen configuration" (click)="reopen(config)">
          <mat-icon>lock_open</mat-icon>
        </button>
        <button *ngIf="config.launched" mat-icon-button color="primary" matTooltip="Print configuration" (click)="print(config)">
          <mat-icon>print</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
